<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-shopping-bag mr-2" />Penjualan Marketplace
            </h5>
            <hr />
            <b-row>
                <b-col md="2">
                    <b-form-group label="No. Faktur">
                        <b-form-input
                            id="filter-noFaktur"
                            placeholder="Cari No. Faktur"
                            v-model="filter.noFaktur"
                            maxlength="50"
                            @keydown.enter="getItems"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2">
                    <b-form-group label="No. Ref">
                        <b-form-input
                            placeholder="Cari No. Ref"
                            v-model="filter.noRef"
                            @keydown.enter="getItems"
                        />
                    </b-form-group>
                </b-col>

                <b-col md="2">
                    <b-form-group label="Status">
                        <b-form-select
                            id="filter-status"
                            v-model="filter.status"
                            :options="optFilterStatus"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2">
                    <b-form-group label="Divisi" id="filter-division">
                        <multiselect
                            id="filter-division"
                            v-model="filter.division"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optFilterDivision"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2">
                    <b-form-group label="Aksi">
                        <b-button
                            id="btn-search"
                            class="d-flex align-items-center flex-nowrap"
                            variant="primary"
                            @click="getItems()"
                        >
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table
                id="marketplace-table"
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive
                class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data penjualan marketplace.
                </template>
                <template v-slot:cell(no_ref)="row">
                    {{ row.item.no_ref || "-" }}
                </template>
                <template v-slot:cell(detail)="row">
                    <div class="small text-muted">
                        <strong>{{ row.item.invoice_division || "-" }}</strong>
                    </div>
                    <div class="small">
                        Harga Original:
                        <strong
                            >Rp.
                            {{
                                $helper.formatThousand(row.item.invoice_total)
                            }}</strong
                        >
                        <br />
                        Harga Marketplace:
                        <strong
                            >Rp.
                            {{ $helper.formatThousand(row.item.total) }}</strong
                        >
                    </div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="getStatusBadge(row.item.status)[0]">{{
                        getStatusBadge(row.item.status)[1]
                    }}</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <router-link :to="'/marketplace/list/' + row.item.id">
                        <b-button
                            id="btn-view-detail"
                            size="sm"
                            variant="primary"
                            v-b-tooltip.hover.top
                            title="Detail Invoice"
                        >
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </router-link>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,

            filter: {
                noFaktur: "",
                noRef: "",
                status: -1,
                division: {
                    id: -1,
                    name: "SEMUA"
                }
            },

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            fields: [
                {
                    key: "invoice_no_faktur",
                    label: "No. Faktur Invoice",
                    sortable: false
                },
                {
                    key: "no_ref",
                    label: "No. Ref Marketplace",
                    sortable: false
                },
                { key: "detail", label: "Detail", sortable: false },
                {
                    key: "status",
                    label: "Status",
                    sortable: false
                },
                { key: "action", label: "Aksi" }
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optFilterStatus: [
                { value: -1, text: "SEMUA" },
                { value: 0, text: "PENDING" },
                { value: 1, text: "SELESAI" },
                { value: 2, text: "VOID" }
            ],

            optFilterDivision: [
                {
                    id: -1,
                    name: "SEMUA"
                }
            ]
        };
    },

    methods: {
        init() {
            this.initStatus = 0;
            let getItems = this.getItems();

            let getDivisions = this.$axios
                .get("division/get-all-filtered")
                .then(res => {
                    res.data.data.map(item => {
                        this.optFilterDivision.push({
                            id: item.id,
                            name: item.name
                        });
                    });
                });

            Promise.all([getItems, getDivisions])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.initStatus = -1;
                });
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage
            );

            if (!this.$helper.isBlank(this.filter.noFaktur)) {
                param += "&filterNoFaktur=" + this.filter.noFaktur;
            }

            if (!this.$helper.isBlank(this.filter.noRef)) {
                param += "&filterNoRef=" + this.filter.noRef;
            }

            if (this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status;
            }

            if (this.filter.division.id != -1) {
                param += "&filterDivision=" + this.filter.division.id;
            }

            if (this.sortBy != null) {
                param +=
                    "&sortBy=" + this.sortBy + "&sortDesc=" + this.sortDesc;
            }

            return this.$axios
                .get("marketplace-sales" + param)
                .then(res => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },

        getStatusBadge(status) {
            switch (status) {
                case 0:
                    return ["danger", "PENDING"];
                case 1:
                    return ["success", "SELESAI"];
                case 2:
                    return ["warning", "VOID"];
                default:
                    return ["light", "-"];
            }
        }
    },

    created() {
        this.init();
        this.$helper.toastFlash(this);
    }
};
</script>
